/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { CardCreditType } from '@coursera/cds-core';

import { productCardDegreeOrCredit } from 'bundles/product-card/components/ProductCardDegreeOrCredit';
import isCreditOffered from 'bundles/search-common/components/search-cards/isCreditOffered';
import isPremiumProduct from 'bundles/search-common/components/search-cards/isPremiumProduct';
import { LEARNING_PRODUCTS } from 'bundles/search-common/constants';

const LearningProductCardBadge = ({
  customBadge,
  productType,
}: {
  customBadge?: React.ReactNode;
  productType?: (typeof LEARNING_PRODUCTS)[keyof typeof LEARNING_PRODUCTS];
}) => {
  if (!customBadge && !productType) {
    return null;
  }

  const creditOffered = productType ? isCreditOffered(productType) : false;
  const premiumProduct = productType ? isPremiumProduct(productType) : false;
  const isDegree = productType === LEARNING_PRODUCTS.Degree;
  const showCreditBadge = premiumProduct && (isDegree || creditOffered);

  if (customBadge) {
    return customBadge;
  } else if (showCreditBadge) {
    return <CardCreditType creditType={productCardDegreeOrCredit(isDegree ?? false)} />;
  } else {
    return null;
  }
};

export default LearningProductCardBadge;
